module.exports = "<!--<app-header></app-header>-->\r\n<div style=\"margin-bottom: 1%; position: relative; top:57px;\">\r\n  <!--<div ng-view></div>-->\r\n  <!--<router-outlet></router-outlet>-->\r\n</div>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app/app.component.html
// module id = ./src/components/app/app.component.html
// module chunks = main